import { render, staticRenderFns } from "./discountPopupContent.vue?vue&type=template&id=6d631378&scoped=true&"
import script from "./discountPopupContent.vue?vue&type=script&lang=js&"
export * from "./discountPopupContent.vue?vue&type=script&lang=js&"
import style0 from "./discountPopupContent.vue?vue&type=style&index=0&id=6d631378&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d631378",
  null
  
)

export default component.exports